module.exports = __webpack_public_path__ + "img/Loader_1.9145283e.svg";